export enum PartnerTypeEnum {
  CO = "clearing-organization",
  NCO = "non-clearing-organization",
  PCO = "proxy-clearing-organization"
}
